import { useEffect } from "react"
import { useAppSelector } from "store"
import { useModals } from "../context/modals/hooks/useModals"

export const useGlobalErrorHandler = () => {
  const { openModal } = useModals()

  const { errorObject } = useAppSelector((state) => state.common)

  useEffect(() => {
    if (errorObject && errorObject.message && errorObject.status > 0) {
      openModal("globalError")
    }
  }, [errorObject])
}
